import { isWeakable } from "./utils";
export var createWeakStorage = function (indexId, storage) {
    if (indexId === void 0) { indexId = 0; }
    if (storage === void 0) { storage = new WeakMap(); }
    return ({
        get: function (args) {
            if (!isWeakable(args[indexId])) {
                console.log('arguments given', args);
                throw new Error("Argument #" + indexId + " expected to be weak-mappable object, " + typeof args[indexId] + " given");
            }
            var test = storage.get(args[indexId]);
            if (test) {
                var a = test.arguments;
                if (a.length === args.length) {
                    for (var i = 0; i < a.length; ++i) {
                        if (a[i] !== args[i]) {
                            return undefined;
                        }
                    }
                    return {
                        value: test.storedValue,
                        index: indexId,
                    };
                }
            }
            return undefined;
        },
        set: function (args, value) {
            storage.set(args[indexId], {
                storedValue: value,
                arguments: args,
            });
            return value;
        },
    });
};
